var map = {
	"./config/locales/en.json": 1408,
	"./config/locales/fr_CA.json": 1409
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1407;


//////////////////
// WEBPACK FOOTER
// ./kiosk \.(html|json|woff|woff2|ttf|eot|svg|gif|png|jpg)$
// module id = 1407
// module chunks = 0